import * as React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

const steps = [
    {
        label: 'Select campaign settings',
        description: `1 more.`,
    },
    {
        label: 'Select campaign settings',
        description: `2.`,
    },
];

export default function Test() {
    const theme = useTheme();
    const steps = [
        { id: 0, name: 'datos_generales', label: 'Datos Generales', },
        { id: 1, name: 'actividades_economicas', label: 'Actividades Económicas', },
        { id: 2, name: 'total_socios', label: 'Total de Socios', },
        { id: 3, name: 'antecedentes', label: 'Antecedentes', },
        { id: 4, name: 'productos_servicios', label: 'Productos y servicios', },
        { id: 5, name: 'contacto_comercial', label: 'Contacto comercial', },
        { id: 6, name: 'datos_publicador', label: 'Datos del publicador', },
    ];
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = steps.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Paper
                square
                elevation={0}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 50,
                    pl: 2,
                    bgcolor: 'background.default',
                }}
            >
                <Typography>{steps[activeStep].label}</Typography>
            </Paper>
            <Box sx={{ maxWidth: 400, width: '100%', p: 2 }}>
                {steps[activeStep].action}
            </Box>
            <MobileStepper
                variant="text"
                steps={steps.length}
                position="bottom"
                activeStep={activeStep}
                nextButton={
                    <Button
                        size="small"
                        onClick={handleNext}
                        disabled={activeStep === steps.length - 1}
                    >
                        Siguiente
                        <KeyboardArrowRight />
                    </Button>
                }
                backButton={
                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                        <KeyboardArrowLeft />
                        Anterior
                    </Button>
                }
            />
        </Box>
    );
}
